import { salesKitEn } from "@nerdjs/sales-kit";
import commonEn from "./en/common.json";
import entitiesEn from "./en/entities.json";

const translations = {
  en: {
    common: commonEn,
    entities: entitiesEn,
    salesKit: salesKitEn,
  },
};

export default translations;
